import Cookies from "universal-cookie";

export const removeTokenFromCookies = () => {
  const cookies = new Cookies();
  cookies.remove("TOKEN", { path: "/" });
  cookies.remove("USER_ID", { path: "/" });
  cookies.remove("USER_FIRSTNAME", { path: "/" });
  cookies.remove("USER_LASTNAME", { path: "/" });
  cookies.remove("USER_EMAIL", { path: "/" });
  cookies.remove("USER_ROLE", { path: "/" });
  cookies.remove("CURR_OFFICE", { path: "/" });
};
